import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  navContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(3),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  title: {
    color: theme.typography.h3.color,
    paddingLeft: '0px',
  },
}));

export default useStyles;
